// Formats browsers show in an <img>. Not heic: most browsers cannot.
const imageExtensions = [
  'png',
  'jpg',
  'jpeg',
  'gif',
  'svg',
  'bmp',
  'webp',
  'avif',
];

const isImageFormat = (extension) => {
  try {
    return imageExtensions.includes(extension.toLowerCase());
  } catch {
    return false;
  }
};

export default isImageFormat;
